<template>
  <div class="tech-card">
    <div class="tech-icon">
      <slot name="icon">
        <svg v-if="iconType === 'ai'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" width="64" height="64">
          <path fill="currentColor" d="M320 0c17.7 0 32 14.3 32 32V96H480c17.7 0 32 14.3 32 32v64H576c17.7 0 32 14.3 32 32v128c0 17.7-14.3 32-32 32H512v80c0 17.7-14.3 32-32 32H352V384H288v96H160c-17.7 0-32-14.3-32-32V384H64c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32H128V128c0-17.7 14.3-32 32-32H288V32c0-17.7 14.3-32 32-32z"/>
        </svg>
        <svg v-else-if="iconType === 'data'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="64" height="64">
          <path fill="currentColor" d="M448 80v48c0 44.2-100.3 80-224 80S0 172.2 0 128V80C0 35.8 100.3 0 224 0S448 35.8 448 80zM393.2 214.7c20.8-7.4 39.9-16.9 54.8-28.6V288c0 44.2-100.3 80-224 80S0 332.2 0 288V186.1c14.9 11.8 34 21.2 54.8 28.6C99.7 230.7 159.5 240 224 240s124.3-9.3 169.2-25.3zM0 346.1c14.9 11.8 34 21.2 54.8 28.6C99.7 390.7 159.5 400 224 400s124.3-9.3 169.2-25.3c20.8-7.4 39.9-16.9 54.8-28.6V432c0 44.2-100.3 80-224 80S0 476.2 0 432V346.1z"/>
        </svg>
        <svg v-else-if="iconType === 'devops'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="64" height="64">
          <path fill="currentColor" d="M418.4 157.9c35.3-8.3 61.6-40 61.6-77.9c0-44.2-35.8-80-80-80c-43.4 0-78.7 34.5-80 77.5L136.2 151.1C121.7 136.8 101.9 128 80 128c-44.2 0-80 35.8-80 80s35.8 80 80 80c12.2 0 23.8-2.7 34.1-7.6L259.7 407.8c-2.4 7.6-3.7 15.8-3.7 24.2c0 44.2 35.8 80 80 80s80-35.8 80-80c0-27.7-14-52.1-35.4-66.4l37.8-207.7z"/>
        </svg>
        <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="64" height="64">
          <path fill="currentColor" d="M64 32C28.7 32 0 60.7 0 96v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm48 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zM64 288c-35.3 0-64 28.7-64 64v64c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64V352c0-35.3-28.7-64-64-64H64zm280 72a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm56 24a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z"/>
        </svg>
      </slot>
    </div>
    <div class="card-body d-flex flex-column align-items-center justify-content-center">
      <h5 class="card-title">{{ title }}</h5>
      <p class="card-text text-center">{{ description }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechnologyCard',
  props: {
    iconType: {
      type: String,
      default: 'ai'
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.card-img-top {
  height: 150px;
  object-fit: contain;
  padding: 15px;
}

.tech-card {
  background: linear-gradient(145deg, #f3f3f3, #e0e0e0);
  border-radius: 15px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.tech-card:hover {
  transform: scale(1.1);
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
}

.tech-card .card-title {
  font-size: 1.2rem;
  font-weight: bold;
  letter-spacing: 1px;
  color: #333;
  margin-top: 15px;
}

.tech-card .card-text {
  font-size: 0.9rem;
  color: #666;
  padding: 0 10px;
}
</style>

